import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import { withTranslation } from 'react-i18next';

import Map from '../../containers/Map/Map';
import { loadGoogleMapsLibraries } from '../Shared/Map/GoogleMapsLoader';
import MapViewHeader from './MapViewHeader';
import MapEmptyState from './MapEmptyState';
import { createReplacePatch } from '../../helpers/patchHelper';
import { entityNames } from '../../config/constants';
import './styles.css';

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slates: [],
      count: undefined,
      ungroupMapPins: props.dashboardSettings
        ? props.dashboardSettings.ungroupMapPins
        : true,
    };
  }

  componentDidMount = () => {
    const { slates } = this.props;
    this.checkCoordinates(slates);

    if (slates) {
      this.setState({ count: slates.length });
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { slates } = nextProps;
    if (!isEqual(slates, this.props.slates)) {
      this.checkCoordinates(slates);
      this.setState({ count: slates.length });
    }
  };

  render() {
    const {
      onMarkerClick,
      t,
    } = this.props;

    const { slates, count, ungroupMapPins } = this.state;
    const isReady = count === slates.length;
    const hasSlatesWithLocation = slates.length > 0;

    return (
      <div className="map-view">
        <MapViewHeader
          ungroupMapPins={ungroupMapPins}
          onGroupPinChange={this.handleGroupPinChange}
          hasData={hasSlatesWithLocation}
        />

        {isReady && hasSlatesWithLocation && (
          <Map
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={
              <div
                className="map-container"
                style={{
                  height: 'calc(100% - 36px)',
                  overflow: 'hidden',
                }}
              />
            }
            mapElement={<div style={{ height: `100%` }} />}
            slates={slates}
            isView
            isClusterer={!ungroupMapPins}
            onMarkerClick={onMarkerClick}
          />
        )}

        {isReady && !hasSlatesWithLocation && (
          <MapEmptyState t={t} />
        )}
      </div>
    );
  }

  handleGroupPinChange = () => {
    const ungroupMapPins = !this.state.ungroupMapPins;
    this.setState({ ungroupMapPins });

    const data = {};
    data.patches = [
      createReplacePatch(`/dashboardSettings/ungroupMapPins`, ungroupMapPins),
    ];

    this.props.updateUser(data, entityNames.DASHBOARD_SETTINGS);
  };

  checkCoordinates = (slates) => {
    const withCoords = [];
    const withoutCoords = [];
    if (slates) {
      slates.forEach((slate) => {
        if (slate.lat && slate.lng) {
          withCoords.push(slate);
        } else {
          withoutCoords.push(slate);
        }
      });
    }
    // Generation guard: geocode callbacks resolve asynchronously, so a
    // late callback from a previous batch of slates must not mutate the
    // count/slates accounting of the batch that replaced it
    this._geocodeGeneration = (this._geocodeGeneration || 0) + 1;
    const generation = this._geocodeGeneration;

    this.setState({ slates: withCoords }, () => {
      this.getCoordsFromAddress(withoutCoords, (slate) => {
        if (generation === this._geocodeGeneration) {
          this.updateSlates(slate);
        }
      });
    });
  };

  getCoordsFromAddress = (slates, callback) => {
    if (!slates.length) {
      return;
    }

    // The Geocoder class is only constructable after the geocoding library
    // has been imported; wait for the shared loader instead of assuming it
    loadGoogleMapsLibraries()
      .then(() => {
        const geocoder = new window.google.maps.Geocoder();

        slates.forEach((slate) => {
          const { address } = slate;
          if (address) {
            geocoder.geocode({ address }, function (results, status) {
              if (status === 'OK') {
                slate.lat = results[0].geometry.location.lat();
                slate.lng = results[0].geometry.location.lng();
                callback(slate);
              } else {
                callback();
              }
            });
          } else {
            callback();
          }
        });
      })
      .catch(() => {
        // Libraries failed to load: still fire every callback so the
        // count converges and the view can render the remaining pins
        slates.forEach(function () {
          callback();
        });
      });
  };

  updateSlates = (slate) => {
    if (slate) {
      const slates = cloneDeep(this.state.slates);
      slates.push(slate);
      this.setState({ slates });
    } else {
      let { count } = this.state;
      this.setState({ count: count - 1 });
    }
  };
}

export default withTranslation()(MapView);
